import { FC, ReactElement, useMemo, useState } from 'react'

import { useGetMenuItems, useI18n } from '../../hooks'
import { useAppSelector } from '../../store'
import { FooterPayload } from '../../types'
import { capitalize } from '../../utils'
import Button from '../atoms/buttons/button'
import LocaleSelection from '../localeSelection'
import Modal from '../modal'
import CompanyInfo from './companyInfo'
import ItemList from './itemList'

import './index.css'

const Footer: FC = (): ReactElement => {
  const { t } = useI18n()
  const { settings } = useAppSelector((state) => state.appConfigReducer)
  const { locale, currency } = settings
  const footerPayload = useGetMenuItems({ footer: true }) as FooterPayload

  const [isLocaleSelectionOpen, setIsLocaleSelectionOpen] = useState(false)

  return useMemo(
    () => (
      <footer>
        <div className="footer__container">
          <div className="footer__container-left">
            <CompanyInfo payload={footerPayload} />
            <div className="footer-language">
              <Button
                aria-label={`${t('LocaleSelection_CurrentSelection')}: ${t('Common_Locale')}: ${capitalize(locale.locale)}, ${t(
                  'Common_Currency'
                )}: ${currency.currencyName}`}
                className="footer-language-btn btn-wrapper"
                onClick={() => setIsLocaleSelectionOpen(true)}
              >
                <span>
                  {capitalize(locale.locale)} - {currency.currencyAbbreviation.toUpperCase()}
                </span>
              </Button>
            </div>
            <Modal
              open={isLocaleSelectionOpen}
              children={<LocaleSelection settings={settings} onClose={() => setIsLocaleSelectionOpen(false)} />}
              onClose={() => setIsLocaleSelectionOpen(false)}
              modalClassName={'language-locale-modal'}
            ></Modal>
          </div>
          <ItemList payload={footerPayload} />
        </div>
        <div className="footer-copyright">
          <p>© Kivuto Solutions Inc. All Rights Reserved. - v5.0</p>
        </div>
      </footer>
    ),
    [currency.currencyAbbreviation, currency.currencyName, footerPayload, isLocaleSelectionOpen, locale.locale, settings, t]
  )
}

export default Footer
